<template>
  <v-container>
    <ViewsContainer
      :moduleName="moduleName"
      :listViewComponent="Kanvan"
      :filterComponent="Filter"
      :data="data"
      :config="'@/components/modules/leads/leads.config'"
      :onCreate="create"
      :onUpdate="update"
      :onRecordUpdate="opportunitiesStore.updateOpportunity"
      :onDelete="remove"
      :show_toolbar="true"
      :show_pagination="false"
      :title="{singular:'Prospecto', plural:'Prospectos'}"
    />
  </v-container>
</template>

<script lang="ts" setup>
import { onMounted, ref, computed } from 'vue';
import { usePreferencesStore } from '@/store/preferences';
import { useOpportunitiesStore } from '@/store/opportunities';
import { useOpportunityStatusesStore } from '@/store/opportunityStatuses';
import { useModuleLayoutFetcher } from '@/composables/useModuleLayoutFetcher';
import { HEADERS, DEFAULT_HEADER_ORDER } from '@/components/modules/opportunities/opportunities.config';
import { useRoute } from 'vue-router';

import Kanvan from '@/components/views/KanbanView.vue';
import Filter from '@/components/drawer/Filters.vue';
import ViewsContainer from '@/components/views/ViewsContainer.vue'

const route = useRoute();
const moduleName = (route.meta.moduleName ?? route.name) as string;
const preferencesStore = usePreferencesStore();

const opportunitiesStore = useOpportunitiesStore();
const opportunityStatusesStore = useOpportunityStatusesStore();


const {
  create,
  update,
  remove,
} = useModuleLayoutFetcher(
  moduleName,
  (params) => opportunityStatusesStore.fetchOpportunityStatuses(params),
  {
    create: opportunitiesStore.createOpportunity,
    update: (data) => opportunitiesStore.updateOpportunity(data.id, data),
    remove: opportunityStatusesStore.deleteOpportunityStatus,
  }
);

onMounted(() => {
  preferencesStore.currentModule = moduleName;
  preferencesStore.setAllModuleHeaders(HEADERS);
  preferencesStore.setDefaultModuleHeaders(
    DEFAULT_HEADER_ORDER
      .map(value => HEADERS.find(header => header.value === value))
      .filter(Boolean) as typeof HEADERS
  );
});

const data = computed(() => opportunityStatusesStore.opportunityStatuses);
</script>
